<template>
  <div class="app-body">

    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="统计年份：" prop="year">
        <el-date-picker
            v-model="queryForm.year"
            type="year"
            placeholder="选择年"
            size="mini"
            style="width: 140px"
            value-format="yyyy"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="外销合同号：" prop="orderCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.orderCode"
            placeholder="请输入外销合同号"
            style="width:160px;"
            :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户：" prop="customerId">
        <customer v-model="queryForm.customerId" clearable></customer>
      </el-form-item>
      <el-form-item label="出口发票号：" prop="receiptCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.receiptCode"
            placeholder="请输入出口发票号"
            style="width:160px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="品番号：" prop="productCode">
        <el-input
            v-model="queryForm.productCode"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入品番号"
        ></el-input>
      </el-form-item>
      <el-form-item label="SKU：" prop="skuCode">
        <el-input
            v-model="queryForm.skuCode"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入SKU"
        ></el-input>
      </el-form-item>
      <el-form-item label="品名：" prop="productName">
        <el-input
            v-model="queryForm.productName"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入品名"
        ></el-input>
      </el-form-item>
      <el-form-item label="颜色：" prop="productColor">
        <el-input
            v-model="queryForm.productColor"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item label="规格：" prop="productSize">
        <el-input
            v-model="queryForm.productSize"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item label="加工单位：" prop="productName">
        <company v-model="queryForm.sellerId" :clearable="true"></company>
      </el-form-item>
      <el-form-item label="订单状态：" prop="orderStatus">
        <el-select v-model="queryForm.orderStatus" size="mini">
          <el-option value="" label="全部"></el-option>
          <el-option value="10" label="进行中"></el-option>
          <el-option value="200" label="已结束"></el-option>
        </el-select>
        <!--        <el-checkbox v-model="queryForm.isEnd" true-label="1" false-label="" @change="reload">已结束订单</el-checkbox>-->
      </el-form-item>
      <el-form-item label="业务员：" prop="businessMan">
        <el-input
            v-model="queryForm.businessMan"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList" size="mini"
        >查询
        </el-button
        >
        <el-button @click="reset" size="mini">重置</el-button>
        <el-button type="warning" size="mini" @click="exportAllData()"
        >导出
        </el-button>
        <span style="margin-left: 10px;">数据统计周期2小时一次，如需要临时刷新数据,可点击表格中的刷新按钮</span>
        <span style="color: red;margin-left: 10px;" v-if="waitTime>0">文件生成中，请稍后（{{waitTime}}）</span>
        <file-link file-type="back" :file-url="downloadUrl" v-show="false" ref="fileLink"></file-link>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :query-form="queryForm" url="/trade/boxform/report"
                :summaries-column="['saleAmount', 'costAmount', 'count']" :after-table-binding="afterTableBinding">
      <el-table-column
          prop="receiptCode"
          label="发票号" align="center" header-align="center"
      ></el-table-column>
      <el-table-column
          prop="makeCompanyName"
          label="加工单位" align="center" header-align="center" :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="agreementCode"
          label="合同号"
          align="left" header-align="center"
      >
        <template #default="{row}">
          <i class="el-icon-refresh" style="margin-right:4px;color:#409EFF;cursor: pointer"
             @click="caculeAll(row.orderId)"></i>
          <span>{{ row.agreementCode }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="productCode"
          label="品番号"
          align="center" header-align="center"
      ></el-table-column>
      <el-table-column
          prop="skuCode"
          label="SKU"
          align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="productName" label="品名" align="center" header-align="center"></el-table-column>
      <el-table-column prop="color" label="颜色" align="center" header-align="center"></el-table-column>
      <el-table-column prop="size" label="规格" align="center" header-align="center"></el-table-column>
      <el-table-column prop="count" label="出口数量" width="80" align="center" header-align="center"></el-table-column>
      <el-table-column
          prop="salePrice"
          label="外销单价"
          align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="saleAmount" label="外销额" width="90" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="costPrice" label="成本价格" width="80" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="receiptPrice" label="开票单价" width="80" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="costAmount" label="成本金额" width="90" align="center" header-align="center">
        <template #default="{row}">
          <span v-if="row.orderStatus!==200" style="color: red;" v-text="row.costAmount"></span>
          <span v-else v-text="row.costAmount"></span>
        </template>
      </el-table-column>
      <el-table-column label="付款发票号" align="center" header-align="center" width="100"
                       :show-overflow-tooltip="true">
        <template #default="{row}">
          <el-tag size="mini" type="primary" v-for="item in row.receiptDetails" :key="item.id">
            【{{ item.sellerName }}】{{ item.receiptCode }}：{{ item.count }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="换汇" width="80" align="center" header-align="center"></el-table-column>
      <el-table-column prop="shipDate" label="日期" width="100" align="center" header-align="center"></el-table-column>
      <el-table-column
          prop="customerName"
          label="客户名称"
          align="center" header-align="center" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="businessMan"
          label="业务员"
          width="80" align="center" header-align="center" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="creatorName"
          label="制单人"
          width="80" align="center" header-align="center"
      ></el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import moment from 'moment'
import SweetTable from '@/mixins/SweetTable'
import qs from 'qs'
import Cookies from 'js-cookie'
import FileLink from '@/components/FileLink.vue'

export default {
  components: { FileLink },
  mixins: [SweetTable],
  data () {
    return {
      downloadUrl:'',
      queryForm: {
        year: '',
        orderCode: '',
        receiptCode: '',
        customerId: '',
        boxType: 'outlet',
        sellerId: '',
        isEnd: '',
        productCode: '',
        productName: '',
        skuCode: '',
        productColor: '',
        productSize: '',
        orderStatus: '10',
        businessMan:''
      },
      downTimer:null,
      waitTime: 0,
    }
  },
  activated () {
    let localQueryForm = window.localStorage.getItem('trade-report-sell-report')
    if (localQueryForm) {
      this.queryForm = JSON.parse(localQueryForm)
    }
  },
  methods: {
    reset () {
      this.$refs.queryForm.resetFields()
      this.$refs.table.reload()
    },
    //导出全部数据
    async exportAllData () {
      let exportUrl = `/trade/boxform/report/export`
      var params = qs.stringify({
        token: Cookies.get('token'),
        ...this.queryForm,
      })
      this.$http.get(exportUrl, { params: this.queryForm })
      this.downTimer = window.setInterval(()=>{this.getReportFile()},1000)
    },
    getReportFile(){
      this.waitTime++
      this.$http.get('/trade/boxform/report/file', { params: { fileName:'出口统计'} }).then(({ data: res }) => {
        if(res.code===0&&res.data){
          this.downTimer && clearInterval(this.downTimer)
          this.waitTime = 0
          this.downloadUrl = res.data.substring(res.data.lastIndexOf('/')+1)
          this.$nextTick(() => {
            this.$refs.fileLink.startDownload(this.downloadUrl,'出口统计.xlsx')
          })
        }else if(res.code!==0){
          this.$message.error(res.msg)
        }
      })
    },
    caculeAll (id) {
      let loading = this.$loading()
      this.$api.get(`/trade/boxform/caculeall`, { params: { orderId: id } }).then(() => {
        this.getDataList()
        loading.close()
      }).catch(e => {
        loading.close()
      })
    },
    afterTableBinding (dataList) {
      window.localStorage.setItem('trade-report-sell-report', JSON.stringify(this.queryForm))
    }
  }
}
</script>
